module.exports = __webpack_public_path__ + "static/media/2.db44d623.jpg";